import React from "react";
import { Link } from "gatsby";

import styles from "./intro.module.less";

const Intro = () => (
  <div className={styles.content}>
    <div className={styles.wrapper}>
      <div className={styles.headWrapper}>
        <Link to="/" className={styles.logo} />
        <a href="mailto:info@beeonquest.com?subject=Request for support" target="_blank" rel="noopener noreferrer" className={styles.support}>Support</a>
      </div>
      <div className={styles.mainLabel}>
        <div>
          <div className={styles.label}>Attendee</div>
          <div className={styles.label}>Reward</div>
          <div className={styles.label}>Program</div>
        </div>
        <div className={styles.desc}>
          <div className={styles.text}>
            <b>Attendee Reward Program</b> encourages Event Attendees to actively explore the event floor and participate in conversations with Exhibitors.
          </div>
          <div className={styles.text}>
            <b>Attendee Reward Program</b> does not only increase event efficiency but also provides additional revenue stream to Event Organizers.
          </div>
        </div>
      </div>
      <div className={styles.mobileDesc}>
        <div className={styles.text}>
          <b>Attendee Reward Program</b> encourages Event Attendees to actively explore the event floor and participate in conversations with Exhibitors.
        </div>
        <div className={styles.text}>
          <b>Attendee Reward Program</b> does not only increase event efficiency but also provides additional revenue stream to Event Organizers.
        </div>
      </div>
    </div>
  </div>
);

export default Intro;
